import eleanorPic from "@/public/images/artists/eleanor.png";
import { Artist } from "@/types/types";

export const eleanor = {
  id: "148",
  name: "Eleanor",
  image: eleanorPic,
  description: `Eleanor's voice carries a refined warmth, blending clarity with depth. Her tone is commanding and smooth, free of sentimentality, exuding a modern sophistication that resonates with confidence. With a distinctive, velvety timbre, her voice carries a polished edge that captivates and enthralls.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Feleanor-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Female",
    tags: {
      primary: ["Dance", "Jazz", "RnB", "Soul", "Unprocessed"],
      secondary: [],
    },
    pitchRange: {
      categories: {
        low: "Low",
        high: "High",
      },
      specific: {
        low: 59,
        high: 72,
      },
      sweetSpot: 63,
    },
  },
} as const satisfies Artist;
